<template>
    <div v-html="alipay"></div>
</template>

<script>
import pay from '@/javaApi/pay'
const payModel = new pay()
export default {
  name: "Alipay",
  data(){
    return{
      alipay: '',
      money: '',
      recordId:'',
      type:0,
    }
  },
  created(){
    let param = this.$route.query;
    this.money = param.money
    this.recordId = param.recordId
    this.type = param.type;
    if(parseFloat(this.recordId) >0){
      this.getAliPayHtml()
    }
  },
  methods:{
    getAliPayHtml() {
        payModel.getAlipayHtml({
            money:this.money,
            recordId:this.recordId,
            type:this.type
        }).then(response=>{
            if(response.data){
                let result = response.data
                if(result.message){
                    this.$message.error(result.message)
                }else{
                    this.alipay = result
                    this.$nextTick(() => {
                        document.forms[0].submit()
                    })
                }

            }else{
                this.$message.error('调取支付宝页面失败')
            }
        }).catch(error=>{
            console.log(error)
            if(error != 'token invalid'){
                this.$message.error('系统异常请稍后再试！')
            }
        })
    }
  }

}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/views/pc/pay/Alipay.vue